import React, { useEffect, useState } from 'react'
import ValidationAdminHeader from '../components/ValidationAdminHeader'
import validityAdminServices from '../validityAdminServices';
import ValideTillComponent from '../components/ValideTillComponent';
import moment from 'moment';

function PortalValidityList() {

  const [portalList,setPortalList] = useState(null);
  const [manualDate,setManualDate] = useState(true);

  const getPortalList = () =>{
    validityAdminServices.getPortalList().then(res=>{
      setPortalList(res.data)
    }).catch(error=>{

    })
  }

  useEffect(()=>{
    getPortalList();
  },[])

  const updateManualStatus = () =>{
    if(moment().hour() > 17){
      setManualDate(false)
    }
  }

  const [password,setPassword] = useState("");


  if(password !== "1516"){
    return(
      <div className='container-fluid'>
        <div className='row mt-5'>
          <div className='col-md-3'></div>
          <div className='col-md-6'>
            <div className='card'>
              <div className='card-header text-danger'>Enter Password to continue</div>
              <div className='card-body'>
                <div className="input-group mb-3">
                    <span className="input-group-text" id="basic-addon1">Enter Password</span>
                    <input className='form-control' type='text' value={password} onChange={(e)=>setPassword(e.target.value)} />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  } else {

    return (
      <>
        <ValidationAdminHeader/>
          <div className='container-fluid'>
            <table className='table table-bordered table-striped mt-3'>
              <thead>
                <tr>
                  <th colSpan={6} className='table-dark text-center'>Valid Date Manager</th>
                </tr>
                <tr>
                  <th>#</th>
                  <th>Portal Id</th>
                  <th>Portal Name</th>
                  <th>Api Server</th>
                  <th>Admin Portal</th>
                  {/* <th>Notification Server</th> */}
                  <th>Valid Till <br/><button className='btn btn-link' onClick={updateManualStatus} >Get All (Allowed After 5 PM)  </button> </th>
                </tr>
              </thead>
              <tbody>
                  {portalList && portalList.map((portal,i)=>
                    <tr key={i}>
                      <td>{i+1}</td>
                      <td>{portal.portalId}</td>
                      <td>{portal.title}</td>
                      <td>{portal.url}</td>
                      <td>
                        {portal.url==="https://api-n.gtoken.in/"?
                            <a href="http://mq.gtoken.in" className='btn btn-link'>http://mq.gtoken.in</a>
                            :
                            <a href="http://ak.gtoken.in" className='btn btn-link'>http://ak.gtoken.in</a>
                        }
                      </td>
                      {/* <td>{portal.notificationUrl}</td> */}
                      <td><ValideTillComponent portal={portal} manualDate={manualDate} /></td>
                    </tr>
                  )}
              </tbody>
            </table>
            
          </div>
      </>
    )
  }
}

export default PortalValidityList